export default __webpack_public_path__ + "static/media/hht2_ep18_speaking_04.d01bd42b.png";